import { createTheme } from '@mui/material/styles';

/** 사이트 공통 테마. 브랜드 색과 반응형 기준점을 한 곳에서 관리한다. */
const theme = createTheme({
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 },
  },
  palette: {
    primary: { main: '#EC9F46' },
    secondary: { main: '#5A4231' },
    background: { default: '#FCFCFC' },
    text: { primary: '#3d2f24' },
  },
  typography: {
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Malgun Gothic', 'Apple SD Gothic Neo', 'Roboto', sans-serif",
  },
  components: {
    MuiTextField: { defaultProps: { size: 'small' } },
    MuiCssBaseline: {
      styleOverrides: {
        body: { backgroundColor: '#FCFCFC' },
      },
    },
  },
});

export default theme;
